/* ============================================================
   EMPRESS FIND MY PERFECT FIT  v2  (Sep 2026)
   Chart = official AUG 2026 sizing chart. Each size has a
   lower and upper bound per measurement. Sizes are found by
   pure lookup, fit preference is applied afterwards:
     relaxed  = the size your waist sits in
     fitted   = one size down (Empress stretch does the rest)
   Bottoms follow the waist. Crops follow bust and waist.
   Dresses and tops offer the hip size as the roomier option.
   ============================================================ */
(function () {
'use strict';

/* ── SIZE CHART (cm). [min, max] per measurement ─────────── */
var CHART = [
  { name: 'XS', aus: '6',     ausMin: 6,  ausMax: 7,  bust: [70, 80],   waist: [55, 65],   hip: [85, 95],   thigh: [50, 60]   },
  { name: 'S',  aus: '8-10',  ausMin: 8,  ausMax: 11, bust: [80, 95],   waist: [65, 80],   hip: [95, 110],  thigh: [60, 70]   },
  { name: 'M',  aus: '12-14', ausMin: 12, ausMax: 15, bust: [95, 110],  waist: [80, 95],   hip: [110, 120], thigh: [70, 80]   },
  { name: 'L',  aus: '16-18', ausMin: 16, ausMax: 19, bust: [110, 120], waist: [95, 110],  hip: [120, 130], thigh: [80, 90]   },
  { name: '1X', aus: '20-22', ausMin: 20, ausMax: 23, bust: [120, 130], waist: [110, 125], hip: [130, 140], thigh: [90, 100]  },
  { name: '2X', aus: '24-26', ausMin: 24, ausMax: 27, bust: [130, 140], waist: [125, 140], hip: [140, 150], thigh: [100, 110] },
  { name: '3X', aus: '28-30', ausMin: 28, ausMax: 32, bust: [140, 150], waist: [140, 150], hip: [150, 160], thigh: [110, 120] }
];
var LAST = CHART.length - 1;
var FIELDS = ['bust', 'waist', 'hip', 'thigh'];
var STORAGE_KEY = 'efc:fit:v2';
/* Bump when the chart or rules change. A saved result from an older version is
   recomputed from her saved measurements the next time the calculator loads. */
var LOGIC_VERSION = '2026-09-23c';

/* Pure lookup. Boundary values belong to the larger size. */
function lookup(cm, field) {
  if (cm == null || isNaN(cm)) return null;
  if (cm < CHART[0][field][0]) return { idx: 0, below: true, above: false, boundary: false };
  if (cm >= CHART[LAST][field][1]) return { idx: LAST, below: false, above: true, boundary: false };
  for (var i = 0; i < CHART.length; i++) {
    var r = CHART[i][field];
    if (cm >= r[0] && cm < r[1]) return { idx: i, below: false, above: false, boundary: cm === r[0] && i > 0 };
  }
  return { idx: LAST, below: false, above: false, boundary: false };
}
function clamp(i) { return Math.max(0, Math.min(LAST, i)); }
function nm(i) { return CHART[clamp(i)].name; }
function ausIdx(str) {
  var n = parseInt(String(str || '').replace(/[^0-9]/g, ''), 10);
  if (!n) return null;
  for (var i = 0; i < CHART.length; i++) if (n >= CHART[i].ausMin && n <= CHART[i].ausMax) return i;
  return n < CHART[0].ausMin ? 0 : LAST;
}

/* Apply fit preference to a chart size.
   fittedDown = true  : fitted customers go one size under (B, Sep 2026)
   fittedDown = false : fitted customers get the same size, offered one down (fit team practice) */
function fitSizes(baseIdx, fp, fittedDown) {
  var base = clamp(baseIdx), down = clamp(baseIdx - 1);
  if (fp === 'firm' && fittedDown !== false) return { idx: down, alt: base, altLabel: 'more room' };
  return { idx: base, alt: down, altLabel: 'more support' };
}

/* ── CORE CALCULATION ─────────────────────────────────────── */
var CUPS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
function cupIdx(c) { var i = CUPS.indexOf(String(c || '').toUpperCase().replace('DD', 'E')); return i; }

function calculate(cm, fp, aus, opts) {
  var fd = !!(opts && opts.fittedDown === true);   /* default: fitted = chart size */
  var cup = cupIdx(opts && opts.cup);           /* -1 = not given, 4+ = E cup and up */
  var fullBust = cup >= 4;
  var heightCm = opts && opts.heightCm > 0 ? opts.heightCm : null;
  var b = lookup(cm.bust, 'bust');
  var w = lookup(cm.waist, 'waist');
  var h = lookup(cm.hip, 'hip');
  var t = lookup(cm.thigh, 'thigh');

  var out = { scenario: 'C', bottoms: null, crops: null, other: null, cta: 'none', notes: [], rows: { bottoms: [], crops: [] } };
  var offChart = [b && b.above, w && w.above].filter(Boolean).length;

  /* Scenario A: bust and waist both beyond the chart. Custom make. */
  if (offChart >= 2) {
    out.scenario = 'A';
    out.cta = 'custom';
    return out;
  }

  /* ── BOTTOMS (waist leads) ── */
  if (w) {
    if (w.above) {
      out.bottoms = { custom: true, name: null };
      out.cta = 'custom';
    } else {
      var base = w.idx, driver = 'waist', shape = null, cta = 'none';
      var thighGap = t ? w.idx - t.idx : 0;
      var hipGap = h ? h.idx - w.idx : 0;

      var apple = !!(t && thighGap >= 2), bigPear = !!(h && hipGap >= 3);
      if (apple && h && hipGap >= 2) {
        /* Tummy well above the legs AND hips well above the waist. Dropping under the
           waist is risky with hips that size, so stay on the waist and let the fit team look. */
        shape = 'mixed';
        cta = hipGap >= 3 ? 'form' : 'soft';
      } else if (apple) {
        /* Apple: waist two or more sizes above the thigh. The band stretches, so one
           size under the waist (B's rule, and the fit team's call in 28 of 54 Gorgias
           apple cases vs 20 at the waist size). Fit team check when the gap is wide. */
        shape = 'apple';
        base = Math.max(w.idx - 1, 0);
        if (thighGap >= 3) cta = 'form';
      } else if (bigPear) {
        /* Hip three or more sizes above the waist. One up from the waist, fit team to confirm.
           (A midpoint rule stepped sizes DOWN as the waist crossed a boundary.) */
        shape = 'pear';
        base = w.idx + 1;
        cta = 'form';
      } else {
        if (h && hipGap === 2) shape = 'pear';
        if (t && t.idx - w.idx >= 2) { shape = 'athletic'; cta = 'soft'; }
      }
      /* Apple already took one size off, the fitted shift does not take a second,
         and the alternative offered is the waist size, not a second size down. */
      out.bottoms = fitSizes(base, fp, fd && shape !== 'apple');
      if (shape === 'apple') { out.bottoms.alt = w.idx; out.bottoms.altLabel = 'more room'; }
      /* A size down is only worth offering when her hip and thigh sit at or under the pick. */
      var altDown = out.bottoms.alt < out.bottoms.idx;
      out.bottoms.altOk = altDown
        ? (!h || h.idx <= out.bottoms.idx) && (!t || t.idx <= out.bottoms.idx) && shape !== 'pear' && shape !== 'mixed'
        : out.bottoms.alt !== out.bottoms.idx;
      out.bottoms.driver = driver;
      out.bottoms.shape = shape;
      out.bottoms.waistIdx = w.idx;
      out.bottoms.hipIdx = h ? h.idx : null;
      out.bottoms.thighIdx = t ? t.idx : null;
      out.bottoms.below = !!w.below;
      out.bottoms.boundary = !!w.boundary;
      if (h && h.above) cta = cta === 'form' ? 'form' : 'soft';
      if (t && t.above) cta = cta === 'form' ? 'form' : 'soft';
      if (cta !== 'none') out.cta = cta;
    }
  }

  /* ── CROPS (bust leads, band must fit) ── */
  if (b) {
    if (b.above) {
      out.crops = { custom: true, name: null };
      out.cta = 'custom';
    } else {
      var cbase = b.idx, cdriver = 'bust', cnote = null;
      if (w && !w.above && w.idx > b.idx) { cbase = w.idx; cdriver = 'waist'; cnote = 'band'; }
      else if (fullBust) {
        /* E cup and up: the bust number is real volume, not frame. No cap toward the
           waist and no fitted downshift (Gorgias: squashed and spilling crops). */
        cnote = 'fullBust';
        if (out.cta === 'none') out.cta = 'soft';
      }
      else if (w && !w.above && b.idx - w.idx >= 2) { cbase = w.idx + 1; cnote = 'underbust'; if (out.cta === 'none') out.cta = 'soft'; }
      out.crops = fitSizes(cbase, fp, fd && !fullBust);
      if (fullBust && fp === 'firm') { out.crops.alt = clamp(cbase + 1); out.crops.altLabel = 'more room'; }
      var cAltDown = out.crops.alt < out.crops.idx;
      /* Never offer a size down on crops. Only a size up when the rule went down (fitted setting, full bust). */
      out.crops.altOk = !cAltDown && out.crops.alt !== out.crops.idx;
      out.crops.base = clamp(cbase);
      out.crops.driver = cdriver;
      out.crops.note = cnote;
      out.crops.bustIdx = b.idx;
      out.crops.below = !!b.below;
    }
  }

  /* Names + rows */
  if (out.bottoms && !out.bottoms.custom) { out.bottoms.name = nm(out.bottoms.idx); out.bottoms.altName = nm(out.bottoms.alt); }
  if (out.crops && !out.crops.custom) { out.crops.name = nm(out.crops.idx); out.crops.altName = nm(out.crops.alt); }
  if (w) out.rows.bottoms.push(row('Waist', cm.waist, w, out.bottoms && out.bottoms.driver === 'waist'));
  if (h) out.rows.bottoms.push(row('Hip', cm.hip, h, false));
  if (t) out.rows.bottoms.push(row('Thigh', cm.thigh, t, out.bottoms && out.bottoms.driver === 'thigh'));
  if (b) out.rows.crops.push(row('Bust', cm.bust, b, out.crops && out.crops.driver === 'bust'));
  if (w) out.rows.crops.push(row('Waist', cm.waist, w, out.crops && out.crops.driver === 'waist'));

  /* ── OTHER STYLES (relaxed base: your waist size, hip as the roomier option) ── */
  if (w && !w.above) {
    var waistIdx = w.idx;
    var hipIdx = h && !h.above ? h.idx : (h && h.above ? LAST : null);
    var roomier = hipIdx != null && hipIdx > waistIdx ? hipIdx : null;
    var topBase = out.crops && !out.crops.custom ? out.crops.base : waistIdx;
    out.other = {
      underwear: { idx: waistIdx, option: roomier },
      bikini:    { idx: waistIdx, option: roomier },
      dresses:   { idx: waistIdx, option: roomier },
      lounge:    { idx: waistIdx, option: roomier },
      tees:      { idx: topBase,  option: topBase < LAST ? topBase + 1 : null },
      hoodies:   { idx: topBase,  option: topBase < LAST ? topBase + 1 : null }
    };
  }

  /* Length from height. Ankle Biters are 7/8 on a 160 to 175cm frame. */
  if (heightCm) {
    out.length = heightCm < 160 ? 'petite' : heightCm > 175 ? 'tall' : 'regular';
    out.heightCm = heightCm;
  }
  out.cup = cup >= 0 ? CUPS[cup] : null;

  /* AU dress size sanity check */
  var ai = ausIdx(aus);
  if (ai != null && out.bottoms && !out.bottoms.custom) {
    out.ausIdx = ai;
    out.ausMismatch = Math.abs(ai - out.bottoms.waistIdx) >= 2;
  }

  if (out.scenario === 'C' && out.cta === 'custom') out.scenario = 'B';
  return out;
}
function row(label, cm, lk, key) {
  return { label: label, cm: cm, size: nm(lk.idx), key: !!key, below: lk.below, above: lk.above, boundary: lk.boundary };
}

/* ── FIRST PERSON COPY ────────────────────────────────────── */
function bottomsCopy(r, fp) {
  if (!r || r.custom) return '';
  var s = '<strong>' + r.name + '</strong>', a = '<strong>' + r.altName + '</strong>';
  var tail = r.altOk && r.altName !== r.name ? ' Want ' + r.altLabel + '? Try ' + a + '.' : '';
  var hipBigger = r.hipIdx != null && r.hipIdx > r.idx;
  var out = [];
  if (r.shape === 'apple') {
    out.push('Your waist sits above your legs. Our band stretches, so we go one under your waist size. ' + s + ' is our pick.' + tail);
  } else if (r.shape === 'pear' && r.hipIdx - r.waistIdx >= 3) {
    out.push('Your hip is a few sizes above your waist. ' + s + ' is a good starting point. Our fit team can confirm it for you.');
  } else {
    if (!tail && r.boundary) { /* the on-the-line sentence below carries the pick */ }
    else out.push(!tail
      ? 'Your waist puts you in a ' + s + '.'
      : fp === 'firm' && r.altLabel === 'more room'
        ? 'You like it snug, so we have gone one down from your waist size. ' + s + ' is your pick.' + tail
        : 'We shop your waist. ' + s + ' is your pick.' + tail);
    if (r.shape === 'pear') out.push('Your hip sits higher than your waist. The stretch handles it. For dresses, see the roomier option below.');
    if (r.shape === 'mixed') out.push('Your waist, hips and legs all sit in different sizes. We have stayed on your waist. Our fit team can fine tune this one.');
    if (r.shape === 'athletic') out.push('Strong legs. If your thighs feel snug, size up one in bottoms.');
  }
  var plainShape = r.shape !== 'pear' && r.shape !== 'mixed' && r.shape !== 'apple';
  if (r.boundary && hipBigger && plainShape) {
    out.push('Your waist sits right on the line between ' + nm(r.waistIdx - 1) + ' and ' + nm(r.waistIdx) + '. We go with ' + s + ' because your hip measures a ' + nm(r.hipIdx) + ', and our fabric stretches most through the hip, so ' + s + ' fits you there beautifully.');
  } else {
    if (r.boundary) out.push('Your waist sits right on the line between ' + nm(r.waistIdx - 1) + ' and ' + nm(r.waistIdx) + '.' + (r.altOk && r.alt < r.idx ? ' Down for support, up for comfort.' : ''));
    if (hipBigger && plainShape) out.push('Your hip measures a ' + nm(r.hipIdx) + '. Our fabric stretches most through the hip, so ' + s + ' fits you there beautifully.');
  }
  if (r.below) out.push('Your waist is under our XS range. XS will be relaxed on you. Our fit team can help.');
  return out.join(' ');
}
function cropsCopy(r, fp) {
  if (!r || r.custom) return '';
  var s = '<strong>' + r.name + '</strong>', a = '<strong>' + r.altName + '</strong>';
  var tail = r.altOk && r.altName !== r.name ? ' Want ' + r.altLabel + '? Try ' + a + '.' : '';
  if (r.note === 'band') return 'The band has to fit, so we go by your waist. That puts you in a ' + s + '.' + tail;
  if (r.note === 'fullBust') return 'Full bust, so we follow your bust measurement and do not size down. ' + s + ' is your pick.' + tail + ' Our longline and high support crops will hold you best.';
  if (r.note === 'underbust') return 'Your bust sits well above your waist. ' + s + ' fits your bust and keeps the band comfy.' + tail;
  return (fp === 'firm' ? 'Snug and supportive. ' : 'Comfy and secure. ') + s + ' is your pick.' + tail;
}

/* Length line is off until the Petite and Tall ranges are live (James, Sep 2026).
   Height is still collected and stored so the data is ready. Flip to true to show it. */
var SHOW_LENGTH = false;
function lengthCopy(r) {
  if (!SHOW_LENGTH || !r || !r.length) return '';
  var h = r.heightCm + 'cm';
  if (r.length === 'petite') return '<span class="efc-length"><b>Length.</b> At ' + h + ' our Ankle Biters sit at the ankle or a touch long. Pick Petite lengths where we make them, or we can shorten for a small fee.</span>';
  if (r.length === 'tall') return '<span class="efc-length"><b>Length.</b> At ' + h + ' our Ankle Biters sit above the ankle. Pick full length styles and Tall lengths where we make them.</span>';
  return '<span class="efc-length"><b>Length.</b> At ' + h + ' our Ankle Biters sit at 7/8, as designed.</span>';
}

/* ── WIDGET ───────────────────────────────────────────────── */
function esc(str) { return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
function readStore() { try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null'); } catch (e) { return null; } }
function writeStore(obj) { try { localStorage.setItem(STORAGE_KEY, JSON.stringify(obj)); } catch (e) {} }
function clearStore() { try { localStorage.removeItem(STORAGE_KEY); } catch (e) {} }

document.querySelectorAll('.efc-wrap[data-illustration]').forEach(function (wrap) {
  var ILLUS = wrap.dataset.illustration;
  var EMAIL = wrap.dataset.email || 'hello@empressathleticus.com.au';
  var CAPTURE = wrap.dataset.captureUrl || '';
  var CUSTOMER = wrap.dataset.customerId || '';
  var CONTEXT = wrap.dataset.context || 'page';
  var FITTED_DOWN = wrap.dataset.fittedDown === 'down';
  function opts() { return { fittedDown: FITTED_DOWN, cup: '', heightCm: state.height == null ? null : (state.unit === 'in' ? Math.round(state.height * 2.54) : state.height) }; }
  var mainEl = wrap.querySelector('main');
  var rendered = false;

  var state = { fit: null, unit: 'cm', bust: null, waist: null, hip: null, thigh: null, aus: '', cup: '', height: null, result: null };

  /* Restore last answer so a returning customer lands on her result.
     New device but logged in: her account carries the result (customer metafield), seed from that. */
  var saved = readStore();
  if (wrap.dataset.account) {
    try {
      var acct = JSON.parse(wrap.dataset.account);
      var acctTs = acct && Date.parse(acct.updated) || 0;
      /* Take the account copy when this browser has nothing, or when the account is newer (she re-measured elsewhere). */
      if (acct && acct.measurements && acct.measurements.waist != null && (!saved || acctTs > (saved.ts || 0) + 60000)) {
        saved = { v: 2, logic: 'account', ts: Date.parse(acct.updated) || Date.now(), fit: acct.fit || 'relaxed', unit: 'cm', aus: '', cup: acct.cup || '', height: acct.height || null,
                  measurements: acct.measurements, sizes: acct };
        writeStore(saved);
      }
    } catch (e) {}
  }
  if (saved && saved.fit && saved.measurements) {
    state.fit = saved.fit; state.unit = saved.unit || 'cm';
    FIELDS.forEach(function (f) { state[f] = saved.measurements[f] != null ? saved.measurements[f] : null; });
    state.aus = saved.aus || '';
    state.cup = saved.cup || '';
    state.height = saved.height != null ? saved.height : null;
  }

  function toCm(v) { return v == null ? null : (state.unit === 'in' ? Math.round(v * 2.54 * 10) / 10 : v); }
  function cmAll() { var o = {}; FIELDS.forEach(function (f) { o[f] = toCm(state[f]); }); return o; }
  function shown(f) { return state[f] == null ? '' : state[f] + (state.unit === 'in' ? ' in' : ' cm'); }

  function progress(step) {
    var steps = wrap.querySelectorAll('.efc-progress__step');
    steps.forEach(function (el, i) {
      el.classList.toggle('efc-progress__step--done', i + 1 < step);
      el.classList.toggle('efc-progress__step--active', i + 1 === step);
      var dot = el.querySelector('.efc-progress__dot');
      if (dot) dot.textContent = i + 1 < step ? '✓' : String(i + 1);
    });
    wrap.querySelectorAll('.efc-progress__line').forEach(function (el, i) { el.classList.toggle('efc-progress__line--done', i + 1 < step); });
  }
  function setContent(html) {
    mainEl.innerHTML = html;
    if (!rendered) { rendered = true; return; }
    var acc = wrap.closest('.efc-accordion-body');
    if (!acc || acc.classList.contains('efc-accordion-body--open')) {
      var top = wrap.getBoundingClientRect().top;
      if (top < 0 || top > window.innerHeight * 0.6) wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  function setQuote(text) { var q = wrap.querySelector('.efc-affirmation p'); if (q && text) q.textContent = text; }

  /* ── STEP 1 ── */
  function step1() {
    progress(1);
    var d = wrap.dataset;
    setContent(
      '<div class="efc-step">' +
        '<div class="efc-intro">' +
          '<span class="efc-eyebrow">Step 1 of 3</span>' +
          '<h2 class="efc-h2">' + esc(d.step1Heading || 'How do you like your activewear to feel?') + '</h2>' +
          (d.step1Subtext ? '<p class="efc-sub">' + esc(d.step1Subtext) + '</p>' : '') +
        '</div>' +
        '<div class="efc-fit-cards">' +
          card('firm', d.firmTitle || 'Fitted', d.firmDesc || 'Snug, sculpted, held in.') +
          card('relaxed', d.relaxedTitle || 'Relaxed', d.relaxedDesc || 'Soft, flexible, easy to move in.') +
        '</div>' +
      '</div>');
    wrap.querySelectorAll('.efc-fit-card').forEach(function (c) {
      c.addEventListener('click', function () { state.fit = c.dataset.value; step2(); });
    });
    function card(v, title, desc) {
      return '<button type="button" class="efc-fit-card" data-value="' + v + '" aria-pressed="' + (state.fit === v) + '">' +
        '<span class="efc-fit-card__mark" aria-hidden="true">' + (v === 'firm' ? fittedIcon() : relaxedIcon()) + '</span>' +
        '<span class="efc-fit-card__title">' + esc(title) + '</span>' +
        '<span class="efc-fit-card__desc">' + esc(desc) + '</span>' +
      '</button>';
    }
  }
  /* Fitted: a band held in by two arrows. Relaxed: soft flowing lines. */
  function fittedIcon() { return '<svg viewBox="0 0 32 32" width="30" height="30" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="11" y="9" width="10" height="14" rx="3"/><path d="M2 16h6M30 16h-6"/><path d="M5.5 13.5 8 16l-2.5 2.5M26.5 13.5 24 16l2.5 2.5"/></svg>'; }
  function relaxedIcon() { return '<svg viewBox="0 0 32 32" width="30" height="30" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M4 11c4-4 8 4 12 0s8 4 12 0"/><path d="M4 17c4-4 8 4 12 0s8 4 12 0"/><path d="M4 23c4-4 8 4 12 0s8 4 12 0"/></svg>'; }

  /* ── STEP 2 ── */
  function step2() {
    progress(2);
    setQuote(wrap.dataset.quote2 || '');
    var u = state.unit;
    var d = wrap.dataset;
    var tips = {
      bust:  'Around the fullest part of your chest. Wear an unpadded bra, tape flat.',
      waist: 'Around your natural waist at your belly button. Breathe normally.',
      hip:   'Around the widest part of your booty, about 20cm below your waist.',
      thigh: 'Around the thickest part of one thigh, right under your booty.'
    };
    var ph = { bust: u === 'cm' ? '100' : '39', waist: u === 'cm' ? '90' : '35', hip: u === 'cm' ? '115' : '45', thigh: u === 'cm' ? '75' : '30' };
    function field(f, n, req) {
      return '<div class="efc-field" data-field="' + f + '">' +
        '<label for="efc-' + f + '"><span class="efc-field__num">' + n + '</span> ' + f.charAt(0).toUpperCase() + f.slice(1) + (req ? ' <span class="efc-req">*</span>' : '') + '</label>' +
        '<div class="efc-field__row"><input type="number" id="efc-' + f + '" inputmode="decimal" step="0.1" min="1" max="300" placeholder="' + ph[f] + '" value="' + (state[f] == null ? '' : state[f]) + '" autocomplete="off"' + (req ? ' aria-describedby="efc-waist-err"' : '') + '><span class="efc-field__unit">' + u + '</span></div>' +
        '<p class="efc-tip" id="efc-tip-' + f + '">' + tips[f] + '</p>' +
      '</div>';
    }
    setContent(
      '<div class="efc-step">' +
        '<div class="efc-intro">' +
          '<span class="efc-eyebrow">Step 2 of 3</span>' +
          '<h2 class="efc-h2">Your measurements</h2>' +
          '<p class="efc-sub">Waist is the one we need. Add the rest for a better fit.</p>' +
        '</div>' +
        '<div class="efc-measure">' +
          '<div class="efc-illus">' +
            '<img src="' + esc(ILLUS) + '" alt="Where to measure. 1 bust, 2 waist, 3 hip, 4 thigh." width="500" height="750" loading="lazy">' +
            hotspot(1, 'bust', d.h1Top || 31) + hotspot(2, 'waist', d.h2Top || 47) + hotspot(3, 'hip', d.h3Top || 60) + hotspot(4, 'thigh', d.h4Top || 73) +
          '</div>' +
          '<div class="efc-form">' +
            '<div class="efc-unit" role="group" aria-label="Units">' +
              '<button type="button" class="efc-unit__btn' + (u === 'cm' ? ' is-on' : '') + '" data-unit="cm">cm</button>' +
              '<button type="button" class="efc-unit__btn' + (u === 'in' ? ' is-on' : '') + '" data-unit="in">inches</button>' +
            '</div>' +
            field('waist', 2, true) + field('hip', 3) + field('thigh', 4) + field('bust', 1) +
            /* Cup size question removed Sep 2026 (too subjective, James). The full-bust crops rule
               only fires when a cup is supplied, so it is dormant. Height still collected. */
            '<div class="efc-field">' +
              '<label for="efc-height">Height <span class="efc-opt">optional</span></label>' +
              '<div class="efc-field__row"><input type="number" id="efc-height" inputmode="decimal" step="0.5" min="1" max="250" placeholder="' + (u === 'cm' ? '165' : '65') + '" value="' + (state.height == null ? '' : state.height) + '" autocomplete="off"><span class="efc-field__unit">' + u + '</span></div>' +
            '</div>' +
            '<div class="efc-field">' +
              '<label for="efc-aus">AU dress size <span class="efc-opt">optional</span></label>' +
              '<div class="efc-field__row"><input type="text" id="efc-aus" inputmode="numeric" placeholder="14" value="' + esc(state.aus) + '" autocomplete="off"></div>' +
            '</div>' +
            '<p class="efc-err" id="efc-waist-err" role="alert" hidden>Pop your waist in first. It is the one we need.</p>' +
            '<div class="efc-unit-check" id="efc-unit-check" role="alert" hidden></div>' +
            '<div class="efc-nav">' +
              '<button type="button" class="efc-btn efc-btn--outline" id="efc-back">Back</button>' +
              '<button type="button" class="efc-btn efc-btn--solid" id="efc-next">Find my size</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>');
    function hotspot(n, f, top) {
      return '<button type="button" class="efc-hotspot" style="top:' + parseInt(top, 10) + '%" data-field="' + f + '" aria-label="How to measure ' + f + '" aria-describedby="efc-tip-' + f + '">' + n + '</button>';
    }
    wrap.querySelectorAll('.efc-unit__btn').forEach(function (b) {
      b.addEventListener('click', function () {
        save();
        var from = state.unit, to = b.dataset.unit;
        if (from !== to) FIELDS.concat('height').forEach(function (f) { if (state[f] != null) state[f] = Math.round((to === 'in' ? state[f] / 2.54 : state[f] * 2.54) * 10) / 10; });
        state.unit = to; step2();
      });
    });
    wrap.querySelectorAll('.efc-hotspot').forEach(function (hs) {
      hs.addEventListener('click', function () {
        var f = hs.dataset.field, fld = wrap.querySelector('.efc-field[data-field="' + f + '"]');
        wrap.querySelectorAll('.efc-hotspot').forEach(function (x) { x.classList.toggle('is-on', x === hs); });
        wrap.querySelectorAll('.efc-field').forEach(function (x) { x.classList.toggle('is-on', x === fld); });
        var inp = wrap.querySelector('#efc-' + f); if (inp) { inp.focus({ preventScroll: true }); fld.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
      });
    });
    FIELDS.forEach(function (f) {
      var inp = wrap.querySelector('#efc-' + f);
      inp.addEventListener('focus', function () {
        wrap.querySelectorAll('.efc-hotspot').forEach(function (x) { x.classList.toggle('is-on', x.dataset.field === f); });
        wrap.querySelectorAll('.efc-field').forEach(function (x) { x.classList.toggle('is-on', x.dataset.field === f); });
      });
      inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); go(); } });
    });
    wrap.querySelector('#efc-back').addEventListener('click', step1);
    wrap.querySelector('#efc-next').addEventListener('click', function () { go(false); });
    function go(skipUnitCheck) {
      save();
      if (state.waist == null) {
        var err = wrap.querySelector('#efc-waist-err'); err.hidden = false;
        var wi = wrap.querySelector('#efc-waist'); wi.classList.add('is-error'); wi.focus();
        return;
      }
      /* A waist under 60 in cm mode sits below our XS. Almost always inches typed into a cm form. */
      if (!skipUnitCheck && state.unit === 'cm' && state.waist < 60) {
        var slot = wrap.querySelector('#efc-unit-check');
        if (slot) {
          slot.hidden = false;
          slot.innerHTML = '<p class="efc-body">Those look like inches. Are they?</p>' +
            '<div class="efc-unit-check__btns">' +
              '<button type="button" class="efc-btn efc-btn--solid" id="efc-unit-yes">Yes, inches</button>' +
              '<button type="button" class="efc-btn efc-btn--outline" id="efc-unit-no">No, that is cm</button>' +
            '</div>';
          slot.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          wrap.querySelector('#efc-unit-yes').addEventListener('click', function () { state.unit = 'in'; go(true); });
          wrap.querySelector('#efc-unit-no').addEventListener('click', function () { slot.hidden = true; go(true); });
          return;
        }
      }
      state.result = calculate(cmAll(), state.fit, state.aus, opts());
      persist(); capture();
      step3();
    }
  }
  function save() {
    FIELDS.forEach(function (f) { var el = wrap.querySelector('#efc-' + f); if (el) { var v = parseFloat(el.value); state[f] = isNaN(v) ? null : v; } });
    var a = wrap.querySelector('#efc-aus'); if (a) state.aus = a.value.trim();
    var hEl = wrap.querySelector('#efc-height'); if (hEl) { var hv = parseFloat(hEl.value); state.height = isNaN(hv) ? null : hv; }
    var cEl = wrap.querySelector('#efc-cup'); if (cEl) state.cup = cEl.value;
  }

  /* ── STEP 3 ── */
  function step3() {
    progress(3);
    setQuote(wrap.dataset.quote3 || '');
    var r = state.result, fp = state.fit;
    var html = '<div class="efc-step efc-result">';

    if (r.scenario === 'A') {
      html += '<div class="efc-intro"><span class="efc-eyebrow">Your fit</span><h2 class="efc-h2">Let us make this one for you</h2>' +
        '<p class="efc-sub">Your measurements sit past our chart. We custom make. Send us your details and our fit team will be in touch.</p></div>' +
        formHTML('custom') + '<div class="efc-nav efc-nav--center"><button type="button" class="efc-btn efc-btn--outline" id="efc-restart">Start over</button></div></div>';
      setContent(html); initForm(); bindRestart(); return;
    }

    html += '<div class="efc-intro"><span class="efc-eyebrow">Step 3 of 3</span><h2 class="efc-h2">Your Empress sizes</h2>' +
      '<p class="efc-sub">' + (fp === 'firm' ? 'Fitted and supportive.' : 'Relaxed and comfy.') + ' Sizes below are for activewear.</p></div>';

    html += '<div class="efc-badges">' + badge('Bottoms', r.bottoms) + badge('Crops', r.crops) + '</div>';

    if (r.ausMismatch) html += '<p class="efc-note">You told us AU ' + esc(state.aus) + '. That is usually our ' + nm(r.ausIdx) + '. Our sizes come from your waist, so trust the tape.</p>';

    if (r.bottoms) html += section('Bottoms', r.bottoms, bottomsCopy(r.bottoms, fp) + lengthCopy(r), r.rows.bottoms);
    if (r.crops) html += section('Crops', r.crops, cropsCopy(r.crops, fp), r.rows.crops);
    else if (state.bust == null) html += '<div class="efc-card efc-card--soft"><p class="efc-body">Add your bust and we will size your crops too.</p><button type="button" class="efc-btn efc-btn--outline" id="efc-add-bust">Add bust</button></div>';

    if (r.other) html += otherHTML(r.other);

    if (r.cta === 'custom') html += '<div class="efc-card efc-card--soft"><h3 class="efc-h3">We custom make</h3><p class="efc-body">One of your measurements sits past our chart. We can make it for you. Send us your details.</p><button type="button" class="efc-btn efc-btn--solid" id="efc-open-form">Get a custom fit</button></div>';
    else if (r.cta === 'form') html += '<div class="efc-card efc-card--soft"><h3 class="efc-h3">Want a second opinion?</h3><p class="efc-body">Your measurements vary across your body. That is normal. Our fit team will check this one for you.</p><button type="button" class="efc-btn efc-btn--solid" id="efc-open-form">Ask the fit team</button></div>';
    else html += '<div class="efc-soft"><p class="efc-body">Not sure? Our fit team loves this stuff.</p><button type="button" class="efc-btn efc-btn--outline" id="efc-open-form">Ask the fit team</button></div>';

    html += '<div id="efc-form-slot"></div>' +
      '<div class="efc-nav efc-nav--center"><button type="button" class="efc-btn efc-btn--ghost" id="efc-restart">Start over</button></div></div>';
    setContent(html);

    var open = wrap.querySelector('#efc-open-form');
    if (open) open.addEventListener('click', function () {
      var slot = wrap.querySelector('#efc-form-slot');
      slot.innerHTML = formHTML(r.cta === 'custom' ? 'custom' : 'advice'); initForm();
      open.closest('.efc-card, .efc-soft').hidden = true;
      slot.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    var ab = wrap.querySelector('#efc-add-bust'); if (ab) ab.addEventListener('click', step2);
    bindRestart();
    if (/contact_posted=true/.test(location.search) && !wrap.dataset.postedShown) { wrap.dataset.postedShown = '1'; wrap.querySelector('#efc-form-slot').innerHTML = successHTML(); }
  }
  function badge(label, r) {
    if (!r) return '';
    if (r.custom) return '<div class="efc-badge efc-badge--custom"><span class="efc-badge__label">' + label + '</span><span class="efc-badge__size">Custom</span><span class="efc-badge__alt">made for you</span></div>';
    /* Badges show the size only. Any alternative lives in the card copy, where it can be explained. */
    return '<div class="efc-badge"><span class="efc-badge__label">' + label + '</span><span class="efc-badge__size">' + r.name + '</span></div>';
  }
  function section(title, r, copy, rows) {
    if (r.custom) return '';
    return '<div class="efc-card">' +
      '<h3 class="efc-h3">' + title + '</h3>' +
      (copy ? '<p class="efc-body">' + copy + '</p>' : '') +
      '<table class="efc-rows"><tbody>' + rows.map(function (x) {
        return '<tr' + (x.key ? ' class="is-key"' : '') + '><td>' + x.label + (x.key ? ' <span class="efc-key">leads</span>' : '') + '</td><td>' + x.cm + ' cm</td><td>' + (x.above ? 'past 3X' : x.below ? 'under XS' : x.size) + '</td></tr>';
      }).join('') + '</tbody></table></div>';
  }
  function otherHTML(o) {
    function line(label, e) {
      var v = '<b>' + nm(e.idx) + '</b>';
      if (e.option != null) v += ' <span class="efc-or">or ' + nm(e.option) + ' for more room</span>';
      if (e.idx >= LAST && e.option == null) v = '<b>3X</b> <span class="efc-or">ask us if you want more room</span>';
      return '<tr><td>' + label + '</td><td>' + v + '</td></tr>';
    }
    return '<div class="efc-card"><h3 class="efc-h3">Other Empress styles</h3>' +
      '<p class="efc-body">Standard size first. The roomier option comes from your hip.</p>' +
      '<table class="efc-rows efc-rows--styles"><tbody>' +
        line('Dresses', o.dresses) + line('Lounge pants and joggers', o.lounge) + line('Tees', o.tees) + line('Hoodies', o.hoodies) + line('Underwear', o.underwear) + line('Bikini bottoms', o.bikini) +
      '</tbody></table></div>';
  }
  function bindRestart() {
    var b = wrap.querySelector('#efc-restart');
    if (b) b.addEventListener('click', function () {
      FIELDS.forEach(function (f) { state[f] = null; }); state.aus = ''; state.fit = null; state.result = null; clearStore(); step1();
    });
  }

  /* ── PERSIST + CAPTURE ── */
  function persist() {
    var r = state.result; if (!r) return;
    writeStore({
      v: 2, logic: LOGIC_VERSION, ts: Date.now(), fit: state.fit, unit: state.unit, aus: state.aus, cup: state.cup, height: state.height, length: r.length || null,
      measurements: { bust: state.bust, waist: state.waist, hip: state.hip, thigh: state.thigh },
      sizes: {
        bottoms: r.bottoms && !r.bottoms.custom ? r.bottoms.name : null,
        bottomsAlt: r.bottoms && !r.bottoms.custom && r.bottoms.altName !== r.bottoms.name ? r.bottoms.altName : null,
        crops: r.crops && !r.crops.custom ? r.crops.name : null,
        cropsAlt: r.crops && !r.crops.custom && r.crops.altName !== r.crops.name ? r.crops.altName : null,
        altLabel: state.fit === 'firm' ? 'more room' : 'more support',
        altShow: !!(r.bottoms && !r.bottoms.custom && r.bottoms.altOk && r.bottoms.altName !== r.bottoms.name && (r.bottoms.boundary || (r.bottoms.shape && r.bottoms.shape !== 'none') || r.cta !== 'none')),
        dresses: r.other ? nm(r.other.dresses.idx) : null,
        dressesRoom: r.other && r.other.dresses.option != null ? nm(r.other.dresses.option) : null,
        tops: r.other ? nm(r.other.tees.idx) : null,
        underwear: r.other ? nm(r.other.underwear.idx) : null,
        bikini: r.other ? nm(r.other.bikini.idx) : null
      },
      custom: r.cta === 'custom'
    });
    /* Tell the product page pill to re-read the saved result. Direct call first, event as backup. */
    try { if (typeof window.efcRefreshSizePill === 'function') window.efcRefreshSizePill(); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('efc:fit-updated')); } catch (e) {}
    /* If the pill script has not loaded yet, refresh once it has. */
    setTimeout(function () { try { if (typeof window.efcRefreshSizePill === 'function') window.efcRefreshSizePill(); } catch (e) {} }, 600);
  }
  function capture() {
    var r = state.result, cm = cmAll();
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'fit_calculator_result', fit_preference: state.fit, bottoms_size: r.bottoms && r.bottoms.name, crops_size: r.crops && r.crops.name, scenario: r.scenario, cta: r.cta }); } catch (e) {}
    if (!CAPTURE) return;
    var anon; try { anon = localStorage.getItem('efc:anon') || (Math.random().toString(36).slice(2) + Date.now().toString(36)); localStorage.setItem('efc:anon', anon); } catch (e) { anon = null; }
    var payload = {
      source: CONTEXT, page: location.pathname, anon_id: anon, customer_id: CUSTOMER || null,
      fit_preference: state.fit, unit: state.unit, aus_size: state.aus || null,
      cup_size: state.cup || null, height_cm: opts().heightCm, length: r.length || null,
      bust_cm: cm.bust, waist_cm: cm.waist, hip_cm: cm.hip, thigh_cm: cm.thigh,
      bottoms: r.bottoms && r.bottoms.name, bottoms_alt: r.bottoms && r.bottoms.altName, crops: r.crops && r.crops.name, crops_alt: r.crops && r.crops.altName,
      shape: r.bottoms && r.bottoms.shape, scenario: r.scenario, cta: r.cta, aus_mismatch: !!r.ausMismatch,
      sizes: (readStore() || {}).sizes || null   /* full saved result, written to her account when logged in */
    };
    try { fetch(CAPTURE, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), keepalive: true, mode: 'cors' }).catch(function () {}); } catch (e) {}
  }

  /* ── FIT TEAM FORM ── */
  function formHTML(mode) {
    var r = state.result || {}, cm = cmAll();
    var summary = [
      'Fit calculator request',
      r.bottoms && r.bottoms.name ? 'Bottoms: ' + r.bottoms.name + (r.bottoms.altName ? ' (alt ' + r.bottoms.altName + ')' : '') : '',
      r.crops && r.crops.name ? 'Crops: ' + r.crops.name + (r.crops.altName ? ' (alt ' + r.crops.altName + ')' : '') : '',
      cm.bust != null ? 'Bust: ' + cm.bust + 'cm' : '', cm.waist != null ? 'Waist: ' + cm.waist + 'cm' : '', cm.hip != null ? 'Hip: ' + cm.hip + 'cm' : '', cm.thigh != null ? 'Thigh: ' + cm.thigh + 'cm' : '',
      state.aus ? 'AU size worn: ' + state.aus : '',
      state.cup ? 'Cup: ' + state.cup : '', opts().heightCm ? 'Height: ' + opts().heightCm + 'cm' + (r.length ? ' (' + r.length + ')' : '') : '',
      'Fit preference: ' + (state.fit === 'firm' ? 'Fitted' : 'Relaxed'),
      'Shape flag: ' + ((r.bottoms && r.bottoms.shape) || 'none'), 'Scenario: ' + (r.scenario || '') + ' / ' + (r.cta || ''),
      'Page: ' + location.href
    ].filter(Boolean).join('\n');
    return '<div class="efc-card efc-form-card" id="efc-fit-form">' +
      '<h3 class="efc-h3">' + (mode === 'custom' ? 'Your custom fit' : 'Ask the fit team') + '</h3>' +
      '<p class="efc-body">' + (mode === 'custom' ? 'We make to measure. Fill this in and we will be in touch within 2 business days.' : 'Real people, real answers, within 2 business days.') + '</p>' +
      '<form id="efc-contact-form" action="/contact#efc-fit-form" method="post" accept-charset="UTF-8" novalidate>' +
        '<input type="hidden" name="form_type" value="contact"><input type="hidden" name="utf8" value="✓">' +
        '<input type="hidden" name="contact[tags]" value="fit-calculator' + (mode === 'custom' ? ',custom-size' : '') + '">' +
        '<div class="efc-grid">' +
          '<div class="efc-field"><label for="efc-f-name">Name <span class="efc-req">*</span></label><div class="efc-field__row"><input type="text" id="efc-f-name" name="contact[name]" autocomplete="name" required></div></div>' +
          '<div class="efc-field"><label for="efc-f-email">Email <span class="efc-req">*</span></label><div class="efc-field__row"><input type="email" id="efc-f-email" name="contact[email]" autocomplete="email" required></div></div>' +
          fieldRO('Bust (cm)', 'bust', cm.bust) + fieldRO('Waist (cm)', 'waist', cm.waist) + fieldRO('Hip (cm)', 'hip', cm.hip) + fieldRO('Thigh (cm)', 'thigh', cm.thigh) +
          '<div class="efc-field efc-field--full"><label for="efc-f-notes">Anything else?</label><div class="efc-field__row"><textarea id="efc-f-notes" name="contact[notes]" rows="3" placeholder="Styles you love, past sizes, what felt off."></textarea></div></div>' +
          '<textarea name="contact[body]" hidden aria-hidden="true">' + esc(summary) + '</textarea>' +
        '</div>' +
        '<p class="efc-err" id="efc-form-err" role="alert" hidden>Add your name and email so we can reply.</p>' +
        '<button type="submit" class="efc-btn efc-btn--solid efc-btn--full">Send to the fit team</button>' +
      '</form></div>';
    function fieldRO(label, f, v) { return '<div class="efc-field"><label for="efc-f-' + f + '">' + label + '</label><div class="efc-field__row"><input type="number" id="efc-f-' + f + '" name="contact[' + f + '_cm]" value="' + (v == null ? '' : v) + '"></div></div>'; }
  }
  function successHTML() {
    return '<div class="efc-card efc-success"><span class="efc-success__mark" aria-hidden="true">✓</span><h3 class="efc-h3">Sent. You are amazing for reaching out.</h3><p class="efc-body">Our fit team will be in touch within 2 business days. Remember, you are beautiful.</p></div>';
  }
  function initForm() {
    var form = wrap.querySelector('#efc-contact-form'); if (!form) return;
    var busy = false;
    form.addEventListener('submit', function (e) {
      e.preventDefault(); if (busy) return;
      var name = form.querySelector('#efc-f-name').value.trim(), email = form.querySelector('#efc-f-email').value.trim(), err = form.querySelector('#efc-form-err');
      if (!name || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { err.hidden = false; return; }
      err.hidden = true; busy = true;
      var btn = form.querySelector('[type=submit]'); btn.disabled = true; btn.textContent = 'Sending';
      var data = new FormData(form);
      var csrf = wrap.querySelector('.efc-csrf-form form');
      if (csrf) csrf.querySelectorAll('input[type=hidden]').forEach(function (i) { if (i.name && i.value && !data.has(i.name)) data.set(i.name, i.value); });
      fetch('/contact', { method: 'POST', body: data, redirect: 'follow', credentials: 'same-origin' }).then(function (res) {
        if (!res.ok || /challenge/i.test(res.url)) throw new Error('challenge');
        return res.text();
      }).then(function (text) {
        if (/challenge|captcha/i.test(text) && !/contact_posted/.test(text)) throw new Error('challenge');
        wrap.querySelector('#efc-fit-form').outerHTML = successHTML();
        setTimeout(function () { wrap.dispatchEvent(new CustomEvent('efc:close-accordion', { bubbles: true })); }, 8000);
      }).catch(function () {
        /* Spam check or network issue. Let the browser submit normally, Shopify handles the challenge and returns with contact_posted=true. */
        try { form.removeAttribute('novalidate'); HTMLFormElement.prototype.submit.call(form); }
        catch (e2) { busy = false; btn.disabled = false; btn.textContent = 'Send to the fit team'; err.textContent = 'That did not send. Email us at ' + EMAIL; err.hidden = false; }
      });
    });
  }

  /* ── INIT ── */
  if (state.fit && state.waist != null && saved && saved.sizes) {
    state.result = calculate(cmAll(), state.fit, state.aus, opts());
    if (saved.logic !== LOGIC_VERSION) persist();   /* rules changed since she last ran it: refresh what the product pages show */
    step3();
  } else if (state.fit && state.waist == null) { step2(); }
  else { step1(); }
});
})();
